import React from 'react';
import withIcon from '../utilities/withIcon';

const IconLogoYahooMail = () => {
  return (
    <g>
      <path d="M0 4.408h3.052l1.776 4.474 1.8-4.474H9.6L5.126 15h-2.99l1.224-2.807L0 4.408zm13.059 3.575H9.73L12.685 1H16l-2.941 6.983zm-2.456.669c1.02 0 1.848.814 1.848 1.819s-.827 1.82-1.848 1.82c-1.021 0-1.848-.815-1.848-1.82 0-1.005.827-1.82 1.848-1.82z" />
    </g>
  );
};

export default withIcon(IconLogoYahooMail);
